export enum RegionEnum {
  LT = 'lt',
  LV = 'lv',
  EE = 'ee',
  PERKUJAV = 'pj',
  TARPININKE = 'tp',
  WHITELABEL = 'wl',
  NORIULIVE = 'nl',
  AMEERIKAEESTIS = 'ae',
}

export enum ThemeEnum {
  SHIPZEE = 'default',
  ALTERNATE = 'alt',
  PERKUJAV = 'pj',
  TARPININKE = 'tp',
  WHITELABEL = 'wl',
  NORIULIVE = 'nl',
  AMEERIKAEESTIS = 'ae',
}

export const DefaultRegion = 'default'
